
import { Options, prop, Vue } from "vue-class-component";
import Skeleton from "@/app/ui/components/skeleton/index.vue";
import Icons from "@/app/ui/components/icons/index.vue";
import { PickupCorporateSummary } from "@/domain/entities/ListPickupV2";
import { AccountController } from "@/app/ui/controllers/AccountController";

class Props {
  data = prop<PickupCorporateSummary>({
    type: Object,
    default: () => new PickupCorporateSummary(),
    required: true
  });
  loading = prop<boolean>({
    type: Boolean,
    default: false
  });
}

@Options({
  components: {
    Skeleton,
    Icons
  }
})
class PickupCorporateV2SummaryCard extends Vue.with(Props) {
  formatNumber(value: number) {
    if (!value) return "0";
    return new Intl.NumberFormat(
      AccountController.accountData.accountIsForeign ? "my-MY" : "id-ID"
    ).format(value);
  }
}

export default PickupCorporateV2SummaryCard;
